// extracted by mini-css-extract-plugin
export default {"copyright":"Copyright_copyright__GiLfr","link":"Copyright_link__oQoEz"};